// admin/src/Component/TikTokConversion/List.js
import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton,
    Filter,
    TextInput
} from 'react-admin';

import DownloadTikTokTag from "./DownloadTikTokTag";

const TikTokConversionFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search name" source="name" alwaysOn />
        <TextInput label="Search url" source="url" />
        <TextInput label="Search pixel ID" source="pixel_id" />
    </Filter>
);

export const TikTokConversionList = (props) => (
    <List filters={<TikTokConversionFilter />} {...props} title="TikTok conversions" perPage={25} sort={{ field: 'updateDate' , order: 'DESC' }}>
        <Datagrid>
            <TextField source="name" label="Name" />
            <TextField source="url" label="URL" />
            <TextField source="pixel_id" label="Pixel ID" />
            <DateField source="update_date" sortBy="updateDate" showTime locales="nl-NL" />
            <EditButton />
            <DownloadTikTokTag />
        </Datagrid>
    </List>
);